import { Entity } from "./entity.model";
import { Role } from "./role.model";
import { UserGroup } from "./user-group.model";
import { DeviceRight } from "./device-right.model";

export class Contact extends Entity {
  email: string;
  active: boolean;
  roles: Role[];
  groups?: UserGroup[] | null;
  deviceRights: DeviceRight[];
  phone?: string;

  constructor({
    email,
    active,
    id,
    roles,
    groups,
    deviceRights,
    phone,
  }: {
    email: string;
    active: boolean;
    id: number;
    roles: Role[];
    groups?: UserGroup[] | null;
    deviceRights?: DeviceRight[];
    phone?: string;
  }) {
    super(id);
    this.email = email;
    this.active = active;
    this.roles = (roles || []).map((role) => new Role(role));
    this.groups = groups ? groups.map((group) => new UserGroup(group)) : null;
    this.deviceRights = (deviceRights || []).map((dr) => new DeviceRight(dr));
    this.phone = phone;
  }
}
